const PRIVACY_POLICY_LINK = "https://www.edusocial-project.de/datenschutzerklaerung/datenschutz-edusocial-school-app/";
const EXTERNAL_SCHEME_SECURE = 'https-external://';
const ORIGINAL_SCHEME_SECURE = 'https://';
const EXTERNAL_SCHEME = 'http-external://';
const ORIGINAL_SCHEME = 'http://';
function replaceExternalLinks() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const aLink = document.getElementById("privacy-policy-link")
    aLink.href = PRIVACY_POLICY_LINK;
    if (userAgent.includes('mobile-native-')) {
        aLink.href = aLink.href.replace(ORIGINAL_SCHEME_SECURE,  EXTERNAL_SCHEME_SECURE);
        aLink.href = aLink.href.replace(ORIGINAL_SCHEME, EXTERNAL_SCHEME);
    }
}
document.addEventListener("DOMContentLoaded", function(event) {
    replaceExternalLinks();
});


// WEBPACK FOOTER //
// ./scripts/frontend/external-links.js